// extracted by mini-css-extract-plugin
module.exports = {"firstRowWithControls":"GR63-LC0GTHL1XqHj91vp","secondRowWithControls":"_2EpyvTMLzGuKB46X2WFoar","verticalAlignBlock":"_2zOA3KefwxID9mjbCyIPuL"};